import { createStore } from "redux";
// import thunk from "redux-thunk";
import rootReducer from ".";


const reduxStore = createStore(rootReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());


export default reduxStore;